<template>
  <module-card
    v-bind="params"
    :permissions="permissions"
    :loading="loading"
    :retryFunction="retryFunction"
    :errorText="enums.responses.error"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <div v-if="items.length == 0" class="appointment">
        <div class="appointment__blocked">
          <div class="appointment__blocked__container">
            <i class="bexsicon-calendar appointment__blocked__icon"></i>
            <div class="appointment__blocked__info">
              <span>
                <b>Nenhum compromisso agendado.</b>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <ul class="appointment-list">
          <li
            v-for="(appointment, index) in items"
            class="appointment-list__item"
            @click="openDetails(appointment)"
            :key="index"
          >
            <div class="appointment-list__item-date">
              <span>
                {{appointment.day}}
                {{appointment.weekDay}}
              </span>
            </div>
            <div>
              <p class="appointment-list__item-hour">{{appointment.hour}}</p>
              <h5 class="appointment-list__item-title">{{appointment.title}}</h5>
              <p class="appointment-list__item-place">{{`Local: ${appointment.place}`}}</p>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template slot="actions">
      <v-btn class="slin-btn" @click="goToAppointment" :style="{ color: params.themeColor }">
        <i class="bexsicon-calendar-sm" />
        Ver agenda completa
      </v-btn>
    </template>
  </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import {
  PROFILES,
  IFRAME,
  UNIT,
  SEGMENTATIONS,
  CONFIG,
  EVENTS,
  NOTIFICATIONS,
  EVENT_TYPES
} from '../../utils/constants';
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import notificationTypes from '@/utils/notificationTypes';
export default {
  components: {
    ModuleCard
  },
  computed: {
    segmentations() {
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
      if (product) {
        const constructionStage = enums.constuctionStages[product.stage];
        switch (constructionStage) {
          case 'launch':
            return [
              SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
              SEGMENTATIONS.INDIRECT__USER_ROLE,
              SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE
            ];
            break;
          case 'inConstruction':
            return [
              SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
              SEGMENTATIONS.SFH__REHEARSE_STATUS,
              SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
              SEGMENTATIONS.INDIRECT__USER_ROLE,
              SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE
            ];
            break;
          case 'delivered':
            if (this.$store.getters[UNIT.GET_IS_KEY_DELIVERED]) {
              return [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
              ];
            } else {
              return [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
              ];
            }
            break;
          default:
            return [];
        }
      } else {
        return null;
      }
    },
    items() {
      return this.$store.getters[EVENTS.GET_APPOINTMENT].filter(
        appointment => !appointment.notificationOnly
      );
    }
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ]
    };
  },
  props: {
    lastUpdate: String,
    loading: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    },
    retryFunction: Function
  },
  created() {
    bus.$on('unit:change', this.getScheduledWorkOrders);
    bus.$on('unit:update', this.getScheduledWorkOrders);
    this.getScheduledWorkOrders();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getScheduledWorkOrders);
    bus.$off('unit:update', this.getScheduledWorkOrders);
  },
  methods: {
    async getScheduledWorkOrders() {
      await Promise.all([
        this.$store.dispatch(EVENTS.FETCH_TECHNICAL_ASSISTANCE),
        this.$store.dispatch(EVENTS.FETCH_SCHEDULE)
      ]);
    },
    openDetails(appointment) {
      const notificationInfo = {
        ctx: this,
        notification: {
          id: appointment._id,
          type: notificationTypes[`EVENT`]
        }
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);
      switch (appointment.typeEvent) {
        case EVENT_TYPES.technicalAssistance:
          this.$router.push({
            name: 'appointmentDetail',
            params: { ticketId: appointment.ticketId }
          });
          break;
        case EVENT_TYPES.keyDelivery:
          this.$router.push({ name: 'keyDeliverySchedule' });
          break;
        case EVENT_TYPES.inspection:
          this.$router.push({ name: 'inspectionDetails' });
          break;
        default:
          this.goToAppointment();
          break;
      }
    },
    goToAppointment() {
      this.$router.push({ name: 'appointments' });
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .v-card__text {
  padding-top: 0;
  height: 150px;
  overflow-y: auto;
}
.my-enterprise-iframe {
  border: none;
  margin: 7% auto 0;
  padding: 0;
  height: 100%;
  width: 100% !important;
}

.appointment {
  &__blocked {
    display: block;
    height: 100%;
    background: var(--card-backdrop-color);
    border-radius: 4px;
    color: var(--label-color);

    &__container {
      display: flex;
      padding: 20px;
    }

    &__info {
      font-size: 11px;
      flex: 0.85;
      margin: auto 5px;
    }

    &__icon {
      flex: 0.1;
      color: var(--grey-icon-color);
      font-size: 2.5rem;
      background: #fff;
      border-radius: 50px;
      padding: 10px;
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 1.2rem;
      margin-right: 0.5rem;
    }
  }
}

.appointment-list {
  display: block;
  list-style: none;

  &__item {
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;

    &:not(:last-child) {
      border-bottom: 1px solid #eee;
    }
  }

  &__item-date {
    flex: 40px 0 0;
    text-align: center;
    font-weight: bold;
    margin-right: 10px;
  }

  &__item-hour {
    font-weight: bold;
    margin: 0;
  }

  &__item-title {
    font-size: 14px;
  }

  &__item-place {
    font-size: 12px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/AppointmentCard.vue